import React from 'react';
import { assertUnreachable } from '../utils/TypescriptHelpers';
import { defaultLabelRenderControls, LabelButtonContext } from './LabelHelpers';
import { CertificationLabel } from './certification/CertificationButton';
import { CertificationRenderProps } from './certification/CertificationProps';
import { SensitivityLabel } from './sensitivity/SensitivityButton';
import { SensitivityRenderProps } from './sensitivity/SensitivityProps';
import { LabelRenderControlsWrapper } from './shared/LabelRenderProps';
import { WarningLabel } from './warning/WarningButton';
import { WarningRenderProps } from './warning/WarningProps';

/**
 * NOTE:
 *
 * 1. if dehydrated, we're trusting the presence of category, content item to mean a render should happen
 * 2. if hydrated, we're trusting the presence of any labels in the label lists to mean a render should happen
 *
 * label calls useControlledPopover hook and renders the resulting popover
 * icon is a function used in `getContent` on iconProps
 * panel is a function used in content on useControlledPopover hook's params
 */

type LabelButtonInnerProps = CertificationRenderProps | WarningRenderProps | SensitivityRenderProps
export type LabelButtonProps = LabelButtonInnerProps & LabelRenderControlsWrapper;

function LabelButtonInner(props: LabelButtonProps): JSX.Element {
  switch (props.category) {
    case 'certification':
      return <CertificationLabel {...props} />
    case 'warning':
      return <WarningLabel {...props} />
    case 'sensitivity':
      return <SensitivityLabel {...props} />
    default:
      assertUnreachable(props);
      return <></>;
  }
}

export function LabelButton(props: LabelButtonProps): JSX.Element {
  return (
    <LabelButtonContext.Provider value={props.controls ?? defaultLabelRenderControls}>
      <LabelButtonInner {...props} />
    </LabelButtonContext.Provider >
  );
}
